import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

const FeesManagement = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '80vh', 
        textAlign: 'center' 
      }}
    >
      <ConstructionIcon sx={{ fontSize: 80, color: '#FF9800' }} />
      <Typography variant="h4" sx={{ mb: 2 }}>
        Fees Management
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        This section is currently under development. Please check back later!
      </Typography>
      <Button variant="contained" color="primary">
        Go Back
      </Button>
    </Box>
  );
};

export default FeesManagement;
